import I18nText from './src/main';

/* istanbul ignore next */
I18nText.install = function(Vue) {
  Vue.component(I18nText.name, I18nText);
};

export default I18nText;
